module.exports = __webpack_public_path__ + "img/wbc-logo.23c277e5.png";